import React from 'react';
import PropTypes from "prop-types";
import apiSettings from "../../../../config/api";
import {Button, buttonTypes} from "../../../../components/Button";

const Tour = (props) => {
  const {
    title,
    pricePerson,
    tourPhotos,
    onEditTour,
    tourId,
    deleteTour,
    isNew
  } = props;

  const getPhotoUrl = () => {
    if(tourPhotos && tourPhotos[0] && tourPhotos[0].photoMedium){
      return apiSettings.endpoints.genImageUrl(tourPhotos[0].photoMedium, tourPhotos[0].updatedAt);
    }
    return '/assets/img/noimage.png';
  };

  return (
    <li className="tour__item">
      <div>
        <div className="tour__item-img">
          <img
            src={getPhotoUrl()}
            alt={title}
            onError={(e) => {e.target.src = '/assets/img/noimage.png'}}
          />
        </div>
        <h3 className="tour__item-title">{title}</h3>
        {isNew && <span className="tour__item-notification">Waiting for approval</span>}
      </div>
      <div className="tour__item-buttons">
        <Button name="Edit this tour" type={buttonTypes.AUTHENTICATION} onClick={() => onEditTour(tourId)} />
        <Button name="Delete" type={buttonTypes.DEACTIVATED} onClick={() =>deleteTour(tourId)} />
      </div>
      <div className="tour__item-value">
        <p className="tour__item-price"><span>$</span>{pricePerson}</p>
        <p className="tour__item-person">person</p>
      </div>
    </li>
  )
};


Tour.propTypes = {
  title: PropTypes.string,
  pricePerson: PropTypes.number,
  tourPhotos: PropTypes.array,
  tourId: PropTypes.number,
  onEditTour: PropTypes.func,
  deleteTour: PropTypes.func,
  isNew: PropTypes.bool,
};

export default Tour;


// WEBPACK FOOTER //
// ./src/app/containers/Vendor/Tour/TourList/Tour.js